//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { _slug } from "./helpers"

export default {
  name: 'PanelDetailProject',
  props: ['project'],
  
  computed: {
    headerBgColorClass: function() {
      return 'has-bg-color-'+ _slug(this.project._mapping_project_sector)
    },
    headerBgIconClass: function() {
      return 'has-bg-icon-typeactiviteit_'+ _slug(this.project._mapping_project_typeactiviteit)
    },
    sectorenBgIconClass: function() {
      return 'has-bg-icon-sector_'+ _slug(this.project._mapping_project_sector)
    },
    adres() {
      let str = ''
      if(this.project._mapping_project_straat) str += this.project._mapping_project_straat + ' '
      if(this.project._mapping_project_huisnummer) str += this.project._mapping_project_huisnummer + '<br />'
      if(this.project._mapping_project_postcode) str += this.project._mapping_project_postcode + ' '
      if(this.project._mapping_project_woonplaats) str += this.project._mapping_project_woonplaats
      return str
    },
    onsnetwerk() {
      let str = ''
      if(this.project._mapping_project_onsnetwerk) {
        this.project._mapping_project_onsnetwerk.forEach((f) => {
          str += f + '<br />'
        })
      }
      return str
    },
  }, 
}



// WEBPACK FOOTER //
// ./scripts/vue/PanelDetailProject.vue